import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_MEALS = `${BASE_URL}/api/meals`;

export class MealSuggestionApi {
  static async suggestMeals(text) {
    return (await axiosInstance.post(`${BASE_URL_MEALS}/suggest`, { text }))
      .data;
  }

  static async suggestAlternatives(mealId, note = "") {
    return (
      await axiosInstance.post(`${BASE_URL_MEALS}/${mealId}/alternatives`, {
        text: note,
      })
    ).data;
  }
}
